module.exports = __webpack_public_path__ + "static/media/kenn_btn_richtig.d851f203.jpg";